var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.type,"size":_vm.size,"icon":_vm.icon,"loading":_vm.loading},on:{"click":_vm.handleDownload}},[(!_vm.circle && _vm.buttonName)?_c('span',[_vm._v(_vm._s(_vm.buttonName))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }